export default __webpack_public_path__ + "static/media/north-star-top-up.67c7ba85.png";